import {useAppSelector} from '@/hooks';

export function useSingleActivePosterItemId(pageId?: string): string | null {
  const singleActiveId = useAppSelector((state) => {
    const currentPageId = pageId ?? state.posterEditor.currentPageId;
    if (!currentPageId) {
      return null;
    }

    if (!state.posterEditor.activeItemIds[currentPageId]) {
      return null;
    }

    return state.posterEditor.activeItemIds[currentPageId][0];
  });

  return singleActiveId ?? null;
}
